import { doubleEncode, makePatchRequest } from "../../utils";

type LivestreamSettings = {
	active_speaker_name?: boolean;
	display_name?: string;
	layout?: "gallery_view" | "speaker_view";
	close_caption?: "burnt-in" | "embedded" | "off";
};

type UpdateSessionLivestreamStatusOptions = {
	sessionId: string;
	action: "start" | "stop" | "mode";
	settings?: LivestreamSettings;
};
const updateSessionLivestreamStatus = async (
	token: string,
	options: UpdateSessionLivestreamStatusOptions,
) => {
	await makePatchRequest({
		token,
		pathList: [
			"v2",
			"videosdk",
			"sessions",
			doubleEncode(options.sessionId),
			"livestream",
			"status",
		],
		options: {},
		body: {
			action: options.action,
			settings: options.settings,
		},
	});
	return 204;
};

export const curriedUpdateSessionLivestreamStatus = (token: string) => (
	options: UpdateSessionLivestreamStatusOptions,
) => updateSessionLivestreamStatus(token, options);
